import { FC, useEffect } from 'react';
import ChariotConnect from 'react-chariot-connect';
import theme from 'config/theme';
import Column from 'components/Column';

const styleButton = (button: HTMLButtonElement, hasError: boolean) => {
  button.style.borderRadius = '100px';
  button.style.padding = '0px';
  button.style.justifySelf = 'center';
  button.style.backgroundColor = hasError ? theme.colors.errorRed : '';
};

interface Props {
  onDonationRequest: () => object;
  chariotConnectId: string;
  onSuccess: (response: any) => void;
  onExit?: (e: any) => void;
  disabled?: boolean;
  hasError?: boolean;
}

const ChariotWrapper: FC<Props> = ({
  onDonationRequest,
  chariotConnectId,
  onSuccess,
  onExit,
  disabled,
  hasError,
}) => {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const chariotElement = document.querySelector('chariot-connect');
      const button = chariotElement?.shadowRoot?.querySelector('button');
      if (button) {
        styleButton(button, !!hasError);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [hasError]);

  return (
    <Column $textAlign="center" $width="100%">
      <ChariotConnect
        cid={chariotConnectId}
        onDonationRequest={onDonationRequest}
        theme="LightBlueTheme"
        onSuccess={onSuccess}
        onExit={onExit}
        disabled={disabled}
      />
    </Column>
  );
};

export default ChariotWrapper;
